import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'
import { useGraphQLClient } from 'modules/core/lib/graphql/provider'
import i18n from 'modules/core/lib/i18n'
import { track } from 'modules/core/lib/metrics'

import { DataTableBooking } from 'modules/space_control/hooks/bookings/dataTableBooking'
import { useBulkCancelBooking } from 'modules/space_control/hooks/bookings/useBulkCancelBooking'

type Props = {
  booking: DataTableBooking
  toggleModal: () => void
}
const DeleteModal = ({ booking, toggleModal }: Props) => {
  const graphQLClient = useGraphQLClient()
  const { cancelBooking } = useBulkCancelBooking(booking.id ? [booking.id] : [])
  const onSubmit = async () => {
    asyncAction(() => {
      return Promise.all([
        cancelBooking(),
        track(graphQLClient, trackingEvents.spaceControl.bookings.deleteBooking, {
          type_space: booking.workSpace?.workSpaceTypeValue,
        }),
      ])
    })
    toggleModal()
  }
  const onCloseModal = () => {
    toggleModal()
  }
  return (
    <Modal
      title={i18n.t('settings.locations.location.work_spaces.delete_modal.title', {
        space_name: booking.workSpace?.name,
      })}
      illustration="alert"
      description={i18n.t('settings.locations.location.work_spaces.delete_modal.description', {
        space_name: booking.workSpace?.name,
      })}
      onClose={onCloseModal}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onCloseModal}>
            {i18n.t('settings.locations.location.work_spaces.delete_modal.cancel')}
          </Button>
          <Button submit>
            {i18n.t('settings.locations.location.work_spaces.delete_modal.submit')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default observer(DeleteModal)
